import React from 'react';

const COLORS = {
  online: '#2ecc71',
  idle: '#f1c40f',
  offline: '#95a5a6',
};

function PresenceStatusBadge({ status = 'offline', title }) {
  const color = COLORS[status] || COLORS.offline;
  return (
    <span
      title={title || status}
      style={{
        display: 'inline-block',
        width: 10,
        height: 10,
        borderRadius: '50%',
        backgroundColor: color,
        marginRight: 6,
      }}
    />
  );
}

export default PresenceStatusBadge;
